module.exports = __webpack_public_path__ + "static/media/icon-questions.3ad22e95.svg";